import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pusher from 'react-pusher';
import { Button } from 'react-bootstrap';

import Sidebar from '../components/Deals/Sidebar';
import actions from '../redux/actions';
import actionTypes from '../redux/actionTypes';
import Heading from '../components/Heading';
import SpinnerComponent from '../components/SpinnerComponent';

class DealDetail extends Component {
  tabWidth = 190;

  constructor() {
    super();
    this.state = {
      works: [],
      dealWork: null,
      blocks: [],
      tabs: [],
      tabCount: 0,
      tabIndex: 0,
      blockIndex: 0,
      start: 0,
      showChangeLog: false,
    };
  }

  componentWillMount() {
    const { params } = this.props;

    // this.props.getWorks();

    if (this.props.deal) {
      this.props.loadDealChanges(this.props.deal.id);
      this.props.loadAgreement(this.props.deal.agreement);
      this.props.loadBlockContents(this.props.deal.agreement);
      this.props.loadDealUsers(this.props.deal.id);
    } else if (params && params.dealId) {
      this.props.loadDealChanges(params.dealId);
      this.props.loadDeal(params.dealId);
      this.props.loadDealUsers(params.dealId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      status,
      deal,
      profile,
      dealUsers,
      dealUsersStatus,
      dealChanges,
      agreementsStatus,
    } = nextProps;

    if (profile && dealUsersStatus === actionTypes.DEAL_USERS_GET_SUCCESS) {
      const dealUser = R.find(R.propEq('user', profile.id))(dealUsers);

      if (!dealUser) {
        this.props.alert(
          'error',
          "You don't have permission to access this agreement."
        );
        this.props.router.replace('/agreements');
      }
    }

    if (this.props.status !== status) {
      if (status === actionTypes.DEAL_GET_SUCCESS) {
        this.props.loadAgreement(deal.agreement);
        this.props.loadBlockContents(deal.agreement);
      } else if (status === actionTypes.DEAL_CHANGES_GET_SUCCESS) {
        this.setDealChanges(dealChanges);
      }
    }

    if (
      this.props.agreementsStatus !== agreementsStatus &&
      agreementsStatus === actionTypes.AGREEMENT_DELETE_SUCCESS
    ) {
      // Move to dashboard after delete the deal
      this.props.router.push('/');
    }

    if (deal && deal.agreement) {
      this.setState({ dealWork: deal.work_info });
    }
  }

  setDealChanges(dealChanges) {
    const { profile } = this.props;

    dealChanges.forEach((dealChange) => {
      if (
        dealChange.user === profile.id &&
        dealChange.type === 'change-request-contract-block'
      ) {
        const changes = JSON.parse(dealChange.changes);

        if (changes && changes.contract_block) {
          const block = changes.contract_block;

          this.props.setBlockChanges({
            ...block,
            options: block.changes,
          });
        }
      }
    });
  }

  onPusherChanged = (data) => {
    const { deal, profile } = this.props;

    if (
      parseInt(data.deal, 10) === deal.id &&
      parseInt(data.user, 10) !== profile.id
    ) {
      window.location.reload();
    }
  };

  onPusherFinalized = (data) => {
    const { deal, profile } = this.props;

    if (
      parseInt(data.deal, 10) === deal.id &&
      parseInt(data.user, 10) !== profile.id
    ) {
      if (
        this.props.location.pathname.indexOf(`dealroom/${data.deal}/edit`) ===
        -1
      ) {
        window.location.href = '/agreements';
      } else {
        window.location.reload();
      }
    }
  };

  onPusherAccepted = (data) => {
    const { deal, profile } = this.props;

    if (
      parseInt(data.deal, 10) === deal.id &&
      parseInt(data.user, 10) !== profile.id
    ) {
      window.location.reload();
    }
  };

  onPusherCompleted = (data) => {
    const { deal } = this.props;

    if (parseInt(data.deal, 10) === deal.id) {
      window.setTimeout(() => {
        window.location.href = `/agreements/${data.agreement}/detail`;
      }, 3000);
    }
  };

  onPusherDeleted = (data) => {
    const { deal, profile } = this.props;

    // Move to the dashboard if collaborators are still visiting deal page after deleting the deal
    if (
      parseInt(data.deal, 10) === deal.id &&
      parseInt(data.user, 10) !== profile.id
    ) {
      if (
        this.props.location.pathname.indexOf(`dealroom/${data.deal}/edit`) !==
        -1
      ) {
        window.location.href = '/';
      }
    }
  };

  deleteDeal = () => {
    const { deal } = this.props;

    if (
      confirm(
        'Are you sure you want to delete this agreement? You and your collaborators will lose access to it if you do.'
      )
    ) {
      this.props.deleteAgreement(deal.agreement);
    }
  };

  archiveDeal = (archived) => {
    const { agreement } = this.props;

    if (archived) {
      if (
        confirm(
          'Are you sure you want to unarchive this agreement? Your collaborators will be able to view and participate in this agreement again if you do.'
        )
      ) {
        this.props.updateAgreement({ ...agreement, archived: false });
      }
    } else {
      if (
        confirm(
          'Are you sure you want to archive this agreement? You and your collaborators will lose access to it if you do.'
        )
      ) {
        this.props.updateAgreement({ ...agreement, archived: true });
        this.props.router.replace('/agreements');
      }
    }
  };

  isDealEditPage = () => {
    const { deal } = this.props;

    if (
      deal &&
      this.props.location.pathname.indexOf(`dealroom/${deal.id}/edit`) !== -1
    ) {
      return true;
    }

    return false;
  };

  renderWork() {
    if (this.state.dealWork) {
      const work = this.state.dealWork;

      if (work.type) {
        return <Sidebar fields={work} agreement={this.props.agreement} />;
      }
    }
    return null;
  }

  render() {
    const { agreement, profile } = this.props;

    return (
      <div className="dealroom-detail">
        <Heading text="Agreement Details" />

        {agreement ? (
          <div className="deal-edit-container">
            {this.renderWork()}

            {this.props.children}

            {this.isDealEditPage() &&
              agreement &&
              agreement.user === profile.id && (
                <div>
                  <Button
                    bsStyle="link"
                    className="btn-archive-deal"
                    onClick={() => this.archiveDeal(agreement.archived)}
                  >
                    {agreement.archived ? 'UNARCHIVE' : 'ARCHIVE'}
                  </Button>
                  {agreement.archived && (
                    <Button
                      bsStyle="link"
                      className="btn-delete-deal"
                      onClick={this.deleteDeal}
                    >
                      DELETE
                    </Button>
                  )}
                </div>
              )}
          </div>
        ) : (
          <div>
            <SpinnerComponent size={100} />
            {this.props.children}
          </div>
        )}

        <Pusher
          channel="deal-detail"
          event="redline-changed"
          onUpdate={this.onPusherChanged}
        />
        <Pusher
          channel="deal-detail"
          event="deal-finalized"
          onUpdate={this.onPusherFinalized}
        />
        <Pusher
          channel="deal-detail"
          event="deal-completed"
          onUpdate={this.onPusherCompleted}
        />
        <Pusher
          channel="deal-detail"
          event="deal-accepted"
          onUpdate={this.onPusherAccepted}
        />
        <Pusher
          channel="deal-detail"
          event="deal-deleted"
          onUpdate={this.onPusherDeleted}
        />
        <Pusher
          channel="deal-detail"
          event="deal-archived"
          onUpdate={this.onPusherDeleted}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  workTypes: state.global.workTypes,
  agreement: state.agreements.selectedAgreement,
  agreementsStatus: state.agreements.status,
  deal: state.deals.selectedDeal,
  dealChanges: state.deals.dealChanges,
  dealUsers: state.dealUsers.dealUsers,
  dealUsersStatus: state.dealUsers.status,
  status: state.deals.status,
  error: state.agreements.error,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadDeal: (dealId) => {
    dispatch(actions.getDeal(dealId));
  },
  loadAgreement: (agreementId) => {
    dispatch(actions.getAgreement(agreementId));
  },
  loadBlockContents: (agreementId) => {
    dispatch(actions.getAgreementContractBlockContents(agreementId));
  },
  loadDealChanges: (dealId) => {
    dispatch(actions.getDealChanges(dealId));
  },
  loadDealUsers: (dealId) => {
    dispatch(actions.getDealUsers(dealId));
  },
  setBlockChanges: (changes) => {
    dispatch(actions.setDealBlockChanges(changes));
  },
  deleteAgreement: (id) => {
    dispatch(actions.deleteAgreement(id));
  },
  updateAgreement: (agreement) => {
    dispatch(actions.updateAgreement(agreement.id, agreement));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealDetail);



// WEBPACK FOOTER //
// src/pages/DealDetail.jsx